import { createAction, props } from '@ngrx/store';
import { IDigitalProduct } from '../models/digitalProduct.model';

export const getDigitalProducts = createAction('[Digital Product] Get Digital Products');
export const getDigitalProductsSuccess = createAction('[Digital Product] Get Digital Products success', (digitalProductList: IDigitalProduct[]) => ({ digitalProductList }));
export const getDigitalProductsFailure = createAction('[Digital Product] Get Digital Products failure', props<{ error: string }>());

export const getDigitalProduct = createAction('[Digital Product] Get Digital Product', (digitalProductId: string) => ({ digitalProductId }));
export const getDigitalProductSuccess = createAction('[Digital Product] Get Digital Product success', (digitalProduct: IDigitalProduct) => ({ digitalProduct }));
export const getDigitalProductFailure = createAction('[Digital Product] Get Digital Product failure', props<{ error: string }>());

export const digitalProductActions = {
    getDigitalProducts,
    getDigitalProductsSuccess,
    getDigitalProductsFailure,
    getDigitalProduct,
    getDigitalProductSuccess,
    getDigitalProductFailure
}
